import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';

export default function WhereButton({ whereService, title = 'Where' }) {
  const [content, setContent] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    setContent(null);
  };

  const handleOpen = async () => {
    try {
      const renderedContent = await whereService();
      setContent(renderedContent);
    } catch (error) {
      setErrorMessage(`An error occurred. A log of the error has been generated for tech to review. Please let them know. Error: ${error}`);
    } finally {
      setIsOpen(true);
    }
  };

  const contents = errorMessage ? (
    <DialogContent sx={{ mt: 0, pt: 0 }}>
      {errorMessage}
    </DialogContent>
  ) : (
    <>
      <DialogTitle sx={{ mb: 0, pb: 0 }}>
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
        size="large"
      >
        <CloseIcon fontSize="large" />
      </IconButton>
      <DialogContent sx={{ mt: 0, pt: 0 }}>
        {content}
      </DialogContent>
    </>
  );
  return (
    <>
      <IconButton
        disabled={!whereService}
        onClick={handleOpen}
      >
        <QuestionMarkIcon />
      </IconButton>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
      >
        {contents}
      </Dialog>
    </>
  );
}

WhereButton.propTypes = {
  whereService: PropTypes.func,
  title: PropTypes.string,
};

WhereButton.defaultProps = {
  whereService: null,
  title: 'Where',
};
